import { render } from "./ChartJs.vue?vue&type=template&id=9ebb68b8"
import script from "./ChartJs.vue?vue&type=script&lang=js"
export * from "./ChartJs.vue?vue&type=script&lang=js"

import "./ChartJs.vue?vue&type=style&index=0&id=9ebb68b8&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__